import { CASE_METADATA_TAG, CASES_TAG } from '../constants';
import { api } from '../core';

export const PaginationProductType = {
  LIGHT: 'LIGHT',
  LIGHT_WITHOUT_GDPR: 'LIGHT_WITHOUT_GDPR',
  FULL: 'FULL',
  FULL_WITHOUT_GDPR: 'FULL_WITHOUT_GDPR',
  GDPR_ONLY: 'GDPR_ONLY',
} as const;

export type PaginationProductTypeKeys = (typeof PaginationProductType)[keyof typeof PaginationProductType];

export type CaseCreateResponse = object;

type CaseCreateProps = {
  abortController?: AbortController;
  caseId: string;
  assignedTo?: string;
  caseReference: string;
  dueDate: string; // '2025-01-01';
  isUrgent: boolean;
  gRef: string | null;
  runGdpr: boolean;
  allegationDocumentIds: string[];
  // Optional instructing company (MLS org only). `null` clears any
  // previously-selected value.
  instructingCompanyId?: string | null;
};

const caseCreateApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postCaseCreate: builder.query<CaseCreateResponse, CaseCreateProps>({
      query: ({
        abortController = new AbortController(),
        caseId,
        assignedTo,
        caseReference,
        dueDate,
        isUrgent,
        gRef,
        runGdpr,
        allegationDocumentIds,
        instructingCompanyId,
      }: CaseCreateProps) => ({
        url: 'case/create',
        method: 'POST',
        body: {
          case_id: caseId,
          assigned_to: assignedTo || null,
          case_reference: caseReference,
          due_date: dueDate,
          is_urgent: isUrgent,
          g_ref: gRef,
          runGdpr: runGdpr,
          allegation_document_ids: allegationDocumentIds,
          instructing_company_id: instructingCompanyId ?? null,
        },
        signal: abortController.signal,
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;

          dispatch(api.util.invalidateTags([CASES_TAG, CASE_METADATA_TAG]));
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in postCaseCreate in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyPostCaseCreateQuery } = caseCreateApi;
